import actionTypes from "../actions/actionTypes";

const initialState = {
  selctedShotclassData: [],
  selctedSeriesData: [],
  selctedCollectionData: [],
  shotclassData: [],
  seriesData: [],
  collectionData: [],
  classAndCollectionDataByProgramId: [],
  certificateByProgramId: null,
  originalAllClassNames: [],
};

const distributeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.distributeTypes.SELECTED_SHOTCLASS_DATA:
      return {
        ...state,
        selctedShotclassData: payload,
      };
    case actionTypes.distributeTypes.SELECTED_SERIES_DATA:
      return {
        ...state,
        selctedSeriesData: payload,
      };
    case actionTypes.distributeTypes.SELECTED_COLLECTION_DATA:
      return {
        ...state,
        selctedCollectionData: payload,
      };
    case actionTypes.distributeTypes.SHOTCLASS_DATA:
      return {
        ...state,
        shotclassData: payload,
      };
    case actionTypes.distributeTypes.SERIES_DATA:
      return {
        ...state,
        seriesData: payload,
      };
    case actionTypes.distributeTypes.COLLECTION_DATA:
      return {
        ...state,
        collectionData: payload,
      };
    case actionTypes.distributeTypes.CLASS_AND_COLLECTION_BY_PROGRAM_ID:
      return {
        ...state,
        classAndCollectionDataByProgramId: payload,
      };
    case actionTypes.distributeTypes.CERTIFICATE_BY_PROGRAM_ID:
      return {
        ...state,
        certificateByProgramId: payload,
      };
    case actionTypes.distributeTypes.ALL_CLASS_NAMES:
      return {
        ...state,
        originalAllClassNames: payload,
      };
    default:
      return state;
  }
};

export default distributeReducer;
